import SignUpMediaContainer from './SignUpMediaContainer';
export default SignUpMediaContainer;
